'use client'

import { Button } from '@vinted/web-ui'
import { ComponentProps, useState } from 'react'
import { noop } from 'lodash'

import ConfirmModal from '../../../../ConfirmModal'

type Props = {
  onConfirm: () => Promise<void>
  buttonProps: Omit<ComponentProps<typeof Button>, 'onClick' | 'size'>
  dialogTranslationKeyPrefix: string
}

const GenericReservationDialog = ({
  onConfirm,
  buttonProps,
  dialogTranslationKeyPrefix,
}: Props) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const showDialog = () => setIsDialogVisible(true)
  const hideDialog = () => setIsDialogVisible(false)

  const handleConfirm = async () => {
    setIsLoading(true)

    await onConfirm()

    setIsLoading(false)

    hideDialog()
  }

  return (
    <>
      <Button {...buttonProps} size="medium" onClick={showDialog} />
      <ConfirmModal
        show={isDialogVisible}
        translationsPrefix={dialogTranslationKeyPrefix}
        onConfirm={isLoading ? noop : handleConfirm}
        onCancel={isLoading ? noop : hideDialog}
      />
    </>
  )
}

export default GenericReservationDialog
